import { Record } from 'notadb';
import { SDK_CDN_URL } from '~/common/contants';
import { videoAdaptor } from './adaptors';
import Entrance from './components/Entrance';
import Modal from './components/Modal';
import Player from './components/Player';
import { fetchVideos } from './fetches';
import { store, toggleModal } from './store/modalStore';
import CONFIGS from '../common/configs';
import './styles.scss';
import './global.scss';

type Props = {
  selector: string;
  productId: string;
  userId?: string;
  shop?: string;
  mode?: string;
  logo?: string;
  title?: string;
  buttonText?: string;
};

!(function (): null {
  function onWindowLoad({
    selector,
    productId,
    // userId,
    shop,
    mode = 'release',
    logo,
    title = '방송요약 보기',
    buttonText = '전체 보기',
  }: Props) {
    const parent = document.querySelector<HTMLElement>(selector);
    if (!parent) {
      console.error(`[ERROR]: selector와 일치하는 요소가 없습니다.`);
      return;
    }

    /* ----------------------------- 스타일시트 추가 ----------------------------- */
    const sdkStyleSheet = document.createElement('link');
    const plyrStyleSheet = document.createElement('link');
    [sdkStyleSheet, plyrStyleSheet].forEach((el) => {
      el.rel = 'stylesheet';
    });
    sdkStyleSheet.type = 'text/css';
    sdkStyleSheet.href =
      `${SDK_CDN_URL}/entries/${mode}` +
      (shop ? `/highlight-${shop}` : `/highlight`) +
      '.css';
    plyrStyleSheet.href = 'https://cdn.plyr.io/3.7.8/plyr.css';
    /* -------------------------------------------------------------------------- */

    /* ----------------------------- 폴리필 추가 ----------------------------- */
    const polyfillScript = document.createElement('script');
    polyfillScript.src =
      'https://polyfill.io/v3/polyfill.min.js?features=smoothscroll';
    /* -------------------------------------------------------------------------- */

    document.head.append(sdkStyleSheet, plyrStyleSheet, polyfillScript);

    if (CONFIGS[shop]?.palette) {
      [
        { label: 'plyr-color-main', value: CONFIGS[shop].palette.primary },
        { label: 'bai-primary', value: CONFIGS[shop].palette.primary },
        { label: 'bai-primary10', value: CONFIGS[shop].palette.primary10 },
      ].forEach(({ label, value }) => {
        document.documentElement.style.setProperty(`--${label}`, value);
      });
    }

    fetchVideos(productId)
      .then((res) => videoAdaptor(res))
      .then((list) => {
        if (!list.length) return;

        const element = document.createElement('div');
        element.className = `bai-highlight-entrance`;
        parent.appendChild(element);

        new Entrance({
          target: element,
          data: list,
          title,
          logo,
          buttonText,
          shop,
          onClick: (record: Record) => {
            store.dispatch(toggleModal({ open: true, record }));
          },
        });

        const modal = new Modal({
          target: document.body,
          title,
          logo,
          onClose: () => {
            store.dispatch(toggleModal({ open: false, data: null }));
          },
        });

        store.subscribe(() => {
          const { open, record } = store.getState();
          if (open) {
            const player = new Player({ list, selectedRecord: record });
            modal.setState({ children: player.template() });
            player.setup();
            document.body.style.overflow = 'hidden';
          } else {
            modal.unmount();
            document.body.style.overflow = '';
          }
        });
      });
  }

  function getParams() {
    const [selector, productId, userId, shop, mode, logo, title, buttonText] = [
      'selector',
      'product-id',
      'd-key',
      'shop',
      'mode',
      'logo-image',
      'title',
      'view-all-button-text',
    ].map((value) => document.currentScript.getAttribute(`data-${value}`));

    if (!selector || !productId) {
      console.error(
        `[ERROR]: script 태그에 selector 속성 혹은 product-id 속성을 지정해주세요.`
      );
      return;
    }

    const params = {
      selector,
      productId,
      mode,
      userId,
      shop,
      logo,
      title,
      buttonText,
    };
    Object.keys(params).forEach((key) => {
      if (!params[key as keyof typeof params]) {
        delete params[key as keyof typeof params];
      }
    });
    return params;
  }

  /* ----------------------------- 진입점 ----------------------------- */
  const params = getParams();

  if (document.readyState === 'complete') {
    // safari
    onWindowLoad(params);
  } else {
    window.addEventListener('load', () => {
      onWindowLoad(params);
    });
  }
  return;
})();
